import { Form, Input, Button, Radio, message, FormModel, Select, Cascader, Checkbox,Icon,Upload,Avatar } from 'ant-design-vue';

const { TextArea } = Input;
const plugins = {
  //注册
  install(Vue) {
    Vue.use(Checkbox)
    Vue.use(Avatar)
    Vue.use(Cascader)
    Vue.use(Form);
    Vue.use(Input);
    Vue.use(TextArea);
    Vue.use(Button);
    Vue.use(Radio);
    Vue.use(FormModel);
    Vue.use(Select);
    Vue.use(Icon);
    Vue.use(Upload);
    Vue.prototype.$message = message;
  }
};
export default plugins;
